import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { formatDateValue, toIsoDate } from "../lib/dateFormat";

export default function DateInput({
  value = "",
  onChange,
  className = "",
  style,
  placeholder = "DD-MM-YYYY",
  disabled = false,
  ...inputProps
}) {
  const isoValue = toIsoDate(value);
  const [draft, setDraft] = useState(formatDateValue(isoValue));

  useEffect(() => {
    setDraft(formatDateValue(isoValue));
  }, [isoValue]);

  const emit = (nextValue) => {
    onChange?.({ target: { value: nextValue } });
  };

  const handleTextChange = (event) => {
    const nextText = event.target.value;
    setDraft(nextText);
    if (!nextText.trim()) emit("");
    else {
      const parsed = toIsoDate(nextText);
      if (parsed) emit(parsed);
    }
  };

  const handleCalendarChange = (event) => {
    const nextValue = event.target.value;
    setDraft(formatDateValue(nextValue));
    emit(nextValue);
  };

  return (
    <div className={`date-input-container ${className.includes("w-full") ? "date-input-full" : ""}`} style={style}>
      <input
        {...inputProps}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        value={draft}
        placeholder={placeholder}
        disabled={disabled}
        onChange={handleTextChange}
        onBlur={() => {
          if (draft.trim() && !toIsoDate(draft)) setDraft(formatDateValue(isoValue));
        }}
        className={`date-input-text ${className}`.trim()}
        style={{ ...style, paddingRight: "2.5rem" }}
        aria-label={inputProps["aria-label"] || placeholder}
      />
      <CalendarDays className="date-input-icon" size={16} aria-hidden="true" />
      <input
        type="date"
        value={isoValue}
        disabled={disabled}
        onChange={handleCalendarChange}
        className="date-input-picker"
        aria-label={`Open date picker${inputProps["aria-label"] ? ` for ${inputProps["aria-label"]}` : ""}`}
        tabIndex={-1}
      />
    </div>
  );
}
